import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import React from 'react'

import UserPicker from '../picker/UserPicker'

const UsersFilter = ({ field, ...props }) => {
  field = field || 'userIds'
  const label = 'Usuário'
  const value = useFilterValue(field, [])
  const handleChange = useChangeFilterValue()

  return (
    <div>
      <UserPicker value={value} onChange={handleChange(field)} multiple label={label} {...props} />
    </div>
  )
}

export default UsersFilter
